import styled from 'styled-components'

import Flex from '@ilg-totallymoney/ui/components/Flex'
import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

export const StyledRatesAndFeesCardContent = styled(Flex)`
    border-bottom: 1px dotted ${theme.grey30};

    &:last-of-type {
        border-bottom: 0;
    }
`

export const StyledTooltipButton = styled.button`
    padding: 0;
    background-color: transparent;
    border: 0;
    display: flex;

    ${focusStylesWithRoundedEdges};

    &:hover {
        cursor: pointer;
    }
`
